import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, HStack, Text, VStack } from '@library';
import Modal from '../../../core/components/Modal';
import type { ProductItem } from '../../types';
import Table from '../../../core/components/table/Table';
import TableRow from '../../../core/components/table/TableRow';
import TableCell from '../../../core/components/table/TableCell';
import TableBody from '../../../core/components/table/TableBody';
import ProductImage from '../ProductImage/ProductImage';
import styles from './ProductAttributesModal.module.css';

const ProductAttributesModal = ({
    product,
    onClose,
}: {
    product: ProductItem;
    onClose(): void;
}) => {
    const specificationAttributes = product.specificationAttributes || [];
    return (
        <Modal
            medium
            onClose={onClose}
            data-test-class="productAttributesModal"
        >
            <VStack gap="large">
                <HStack align="center" gap="small">
                    <ProductImage
                        url={product.media[0]?.renditionUrl}
                        size="100px"
                    />
                    <Heading h3>
                        <span className={styles.productName}>
                            {product.name}
                        </span>
                    </Heading>
                </HStack>
                <VStack gap="small">
                    <Text tertiary medium uppercase>
                        <span className={styles.tableTitle}>
                            <FormattedMessage id="specifications" />
                        </span>
                    </Text>
                    <Table striped>
                        <TableBody>
                            {specificationAttributes.map(({ name, value }) => (
                                <TableRow
                                    key={name + value}
                                    data-test-class="productAttributeItem"
                                >
                                    <TableCell>
                                        <Text secondary medium>
                                            {name}
                                        </Text>
                                    </TableCell>
                                    <TableCell>
                                        <Text secondary>{value}</Text>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </VStack>
            </VStack>
        </Modal>
    );
};

export default memo(ProductAttributesModal);
